import { render, staticRenderFns } from "./emoji.vue?vue&type=template&id=72dd7e92"
import script from "./emoji.vue?vue&type=script&lang=js"
export * from "./emoji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports